import Tag from './src/tag';

module.exports = Tag;


// WEBPACK FOOTER //
// ./src/components/tag/index.js